// extracted by mini-css-extract-plugin
export default {"settingsComponentWrapper":"styles_settingsComponentWrapper__wdHml","settingsComponent":"styles_settingsComponent__zKQbl"};